
import React, { useEffect, useState } from "react";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Layout from "../../../components/layouts/Layout";
import UserLogs from "./UserLogs";
import DevicesStatus from "./DevicesStatus";
function DeviceManagement() {


    return (
        <>
            <Layout pageTitleText="Device Management">
                {/* <div className="row">
                    <div className="col-md-12">
                        <header className="headerContainerSearchAction headerContainerUserWithStatus">
                            <div className="titleandButton p-0">
                                <h5 className="m-0">Device Managements</h5>
                                <span></span>
                            </div>
                        </header>
                    </div>
                </div> */}
                <div className="profileDetailWrapper currentHealthIssuesWrapper">
                    <Tabs
                        defaultActiveKey="usersLogs"
                        id="uncontrolled-tab-example"
                        className="tabContainer"
                    >
                        <Tab eventKey="usersLogs" title="Users Logs">
                            <UserLogs />
                        </Tab>
                        <Tab eventKey="devicesStatus" title="Devices Status">
                            <DevicesStatus />
                        </Tab>
                    </Tabs>
                </div>
            </Layout>



        </>
    );
}

export default DeviceManagement